import { render } from "./VehicleTable.vue?vue&type=template&id=21600758"
import script from "./VehicleTable.vue?vue&type=script&lang=js"
export * from "./VehicleTable.vue?vue&type=script&lang=js"

import "./VehicleTable.vue?vue&type=style&index=0&id=21600758&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__